






























































































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "DaysComparatorGuide",
})
export default class DaysComparatorGuide extends Vue {}
